export default () => ({
  dialog: {
    maxWidth: '400px',
  },
  actions: {
    padding: '8px 16px',
  },
});
